import React from 'react';
import * as ga from 'react-ga';
import './suggestion.less';

export interface ISuggestion {
	url: string;
	target: string;
	alt: string;
	image: string;
	title: string;
	layout: string;
	orientation: string;
}

interface ISuggestionProps {
	suggestion: ISuggestion;
}

export class Suggestion extends React.Component<ISuggestionProps> {
	_navigateToSuggestion(target: string, url: string) {
		ga.outboundLink({ label: url }, function() {
			if (target && target !== '_self') {
				window.open(url, target);
			} else {
				window.location.href = url;
			}
		});
	}

	render() {
		const { alt, image, title, layout, orientation, url, target = '_self' } = this.props.suggestion;

		return layout && layout === 'full' ? (
			<div className="suggestion sug-container-full">
				<a target={target} title={title} href={url} onClick={() => this._navigateToSuggestion(target, url)}>
					<img className={`${orientation || 'portrait'}-cover`} src={image} alt={alt || title} />
					<div className="title">{title}</div>
				</a>
			</div>
		) : (
			<div className="suggestion sug-container">
				<a target={target} title={title} href={url} onClick={() => this._navigateToSuggestion(target, url)}>
					<img src={image} alt={alt || title} />
					<div className="title">{title}</div>
				</a>
			</div>
		);
	}
}
